export type TrainingAnswer = string | number | boolean | string[] | number[];
export type TrainingQuestionId = string | number;
export type TrainingBlockId = number | string;
export type TrainingAnswersBlock = Record<TrainingQuestionId, TrainingAnswer>;
export type TrainingAnswers = Record<TrainingBlockId, TrainingAnswersBlock>;

export enum StepType {
  Video,
  Test,
}

export enum TestType {
  Text,
  Variants,
  SingleVariant,
}

type Answer = string | number | boolean;
export type Variant = { title: string; value: Answer };

export type TrainingStep = VideoStep | QuestionStep;
export type TrainingBlock = {
  title: string;
  id: TrainingBlockId;
  steps: TrainingStep[];
};

export type VideoStep = {
  stepType: StepType.Video;
  title?: string;
  url?: string;
  videoId?: string;
};

export type QuestionStep = {
  stepType: StepType.Test;
  question: string;
  type: TestType;
  questionDescription?: string;
  variants?: Variant[];
  id: TrainingQuestionId;
};
